import React from 'react';
import { CircularProgress } from '@mui/material';
import * as SC from './GlobalSpinner.sc';

export const GlobalSpinner = () => {
  return (
    <SC.Container>
      <CircularProgress />
    </SC.Container>
  );
};
